import { Grid } from '@material-ui/core';
import TabComponent from '../../../Core/Controls/Tabs';
import React, { useEffect, useMemo, useState } from 'react';
import { getVehicleInspectionsStatusList } from '../../../Core/Service/vehicleInspectionByStatus-service';
import VehicleInspectionGrid from './InspectionbyStatusGrid';

const VehicleInspectionStatus = (props) => {
    const [statusList, setStatusList] = useState([]);

    useEffect(() => {
        let fetchData = async () => {
            let res = await getVehicleInspectionsStatusList();
            if (res.success) {
                setStatusList(res.data.list);
            }
        };
        fetchData();
    }, []);

    // Allow deep linking to a status, e.g. from the dashboard Inspections card:
    // /VehicleInspectionStatus?statusId=5 opens on the Repair In Progress tab.
    // The "All" tab is index 0; no statusId or statusId 0 lands on it.
    const selectedIndex = useMemo(() => {
        const params = new URLSearchParams(props.location?.search || window.location.search);
        const statusId = params.get('statusId');
        if (statusId == null || statusId === '' || Number(statusId) === 0) return 0;
        if (statusList.length === 0) return undefined;
        const index = statusList.findIndex((s) => Number(s.id) === Number(statusId));
        return index >= 0 ? index + 1 : 0; // +1 accounts for the prepended "All" tab
    }, [props.location?.search, statusList]);

    // Optional event ID carried from the dashboard Inspections card - passes ScheduleEventID
    // to the grid's API endpoint (VehicleInspection/ByStatus?StatusID=X&ScheduleEventID=Y).
    const scheduleEventID = useMemo(() => {
        const params = new URLSearchParams(props.location?.search || window.location.search);
        return params.get('scheduleEventID') || params.get('ScheduleEventID') || '';
    }, [props.location?.search]);

    // Prepend an "All" tab (statusId 0 => API returns every status).
    const insideTabs = [
        {
            label: 'All',
            body: <VehicleInspectionGrid statusId={''} scheduleEventID={scheduleEventID} />
        },
        ...statusList.map((q) => ({
            label: `${q.name}`,
            body: <VehicleInspectionGrid statusId={q.id} scheduleEventID={scheduleEventID} />
        }))
    ];

    return (
        <Grid container item>
            <Grid item style={{ height: '100%', width: '100%' }}>
                <TabComponent tabList={insideTabs} selectedIndex={selectedIndex} />
            </Grid>
        </Grid>
    );
};

export default VehicleInspectionStatus;
